<script>
import SectionCard from '../SectionCard.vue';
import { formatBytes } from 'shared/helpers/FileHelper';
import { brochureName, isImageBrochure } from '../helpers';

// Read-only list of the project's brochures, in their saved order; adding,
// renaming, reordering and removing happen in BrochuresModal.
export default {
  name: 'BrochuresSection',
  components: { SectionCard },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    brochures() {
      return this.project.brochures || [];
    },
  },
  methods: {
    brochureName,
    isImageBrochure,
    formatFileSize(bytes) {
      return formatBytes(bytes, 1);
    },
  },
};
</script>

<template>
  <SectionCard
    section-id="brochures"
    :title="$t('REAL_ESTATE.BROCHURES.TITLE')"
  >
    <template #action>
      <woot-button
        variant="clear"
        size="small"
        icon="edit"
        @click="$emit('edit')"
      >
        {{ $t('REAL_ESTATE.BROCHURES.EDIT_BUTTON') }}
      </woot-button>
    </template>

    <ul v-if="brochures.length" class="list-none m-0 space-y-2">
      <li v-for="brochure in brochures" :key="brochure.brochure_id">
        <a
          :href="brochure.url"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-3 rounded-lg border border-slate-200 dark:border-slate-700 p-2 hover:bg-slate-50 dark:hover:bg-slate-700/50"
        >
          <span
            class="relative w-10 h-10 shrink-0 rounded-md overflow-hidden bg-slate-100 dark:bg-slate-900 flex items-center justify-center text-slate-400"
          >
            <fluent-icon
              :icon="isImageBrochure(brochure) ? 'image' : 'document'"
              size="18"
            />
            <img
              v-if="isImageBrochure(brochure)"
              :src="brochure.url"
              alt=""
              class="absolute inset-0 w-full h-full object-cover"
              @error="$event.target.remove()"
            />
          </span>
          <span class="flex-1 min-w-0">
            <span
              class="block text-sm font-medium text-slate-900 dark:text-slate-100 truncate"
            >
              {{ brochureName(brochure) }}
            </span>
            <span class="block text-xs text-slate-400 truncate">
              {{ brochure.file_name }} ·
              {{ formatFileSize(brochure.file_size) }}
            </span>
          </span>
          <fluent-icon icon="open" size="14" class="shrink-0 text-woot-500" />
        </a>
      </li>
    </ul>
    <p v-else class="text-sm text-slate-400 mb-0">
      {{ $t('REAL_ESTATE.BROCHURES.EMPTY') }}
    </p>
  </SectionCard>
</template>
